// features
import { EXCEL_RESULTS_FILTER_PARAMS } from '../../rate-shop/settings';
import { getFilterParamsByReportType } from '../../fleet-list/settings';
import { FILTER_PARAMS as userParams } from '../../user/settings/filter-params';
import { FILTER_PARAMS as cloItemFilterParams } from '../../clo-items/settings';
import { ORDER_QUOTES_FILTER_PARAMS } from '../../quotes/settings/column-settings';
import { FILTER_PARAMS as branchFilterProps } from '../../branch/settings/filter-params';
import { FILTER_PARAMS as ediParams } from '../../edi-integration/settings/filter-params';
import { FILTER_PARAMS as workOrderFilterParams } from '../../work-order/report/settings';
import { FILTER_PARAMS as carrierFilterProps } from '../../carrier/settings/filter-params';
import { FILTER_PARAMS as iftaFilterProps } from '../../ifta-report/settings/filter-params';
import { cloChargeFilterParams, telChargeFilterParams } from '../../charge-report/settings';
import { FILTER_PARAMS as claimFilterParams } from '../../claim-management/report/settings';
import { FILTER_PARAMS as fuelCardFilterProps } from '../../fuel-cards/settings/filter-params';
import { FILTER_PARAMS as publicCloFilterProps } from '../../public-clo/settings/filter-params';
import { filterProps as inspectionTemplateFilterProps } from '../../template/inspection/helpers';
import { FILTER_PARAMS as importFilterParams } from '../../import-report/settings/filter-params';
import { getFilterProps as getGeoFencingFilterParams } from '../../geo-fencing-location/helpers';
import { FILTER_PARAMS as carrierInsuranceFilterParams } from '../../carrier/insurances/settings';
import { FILTER_PARAMS as compensationGroupFilterParams } from '../../compensation-group/settings';
import { FILTER_PARAMS as tollChargeFilterProps } from '../../toll-charges/settings/filter-params';
import { FILTER_PARAMS as carrierEdiFilterParams } from '../../carrier-edi/settings/filter-params';
import { FILTER_PARAMS as inspectionFilterParams } from '../../inspections/settings/filter-params';
import { getAssignmentHistoryFilterParams } from '../../fleet-profile/settings/assignment-history';
import { getFilterParams as getReferenceFilterProps } from '../../reference/settings/filter-params';
import { FILTER_PARAMS as taskManagementFilterParams } from '../../task-management/report/settings';
import { getCLOFilterParams, getTELFilterParams } from '../../dispatch-board/settings/filter-params';
import { FILTER_PARAMS as masterInvoiceFilterProps } from '../../master-invoice/settings/filter-params';
import { FILTER_PARAMS as driverInvoiceFilterProps } from '../../invoice/driver/settings/filter-params';
import { FILTER_PARAMS as vendorInvoiceFilterProps } from '../../invoice/vendor/settings/filter-params';
import { FILTER_PARAMS as carrierStatisticFilterParams } from '../../carrier-statistic-report/settings';
import { FILTER_PARAMS as telEventFilterParams } from '../../dispatch-report/load/load-events/settings';
import { FILTER_PARAMS as serviceVendorFilterParams } from '../../service-vendor/settings/filter-params';
import { FILTER_PARAMS as fleetAccessorialFilterParams } from '../../fleet-profile/settings/accessorial';
import { FILTER_PARAMS as cloByTelFilterParams } from '../../dispatch-report/order/order-by-load/settings';
import { FILTER_PARAMS as telByCloFilterParams } from '../../dispatch-report/load/load-by-order/settings';
import { FILTER_PARAMS as fleetCompensationFilterParams } from '../../fleet-profile/settings/compensation';
import { FILTER_PARAMS as carrierInvoiceFilterParams } from '../../invoice/carrier/settings/filter-params';
import { FILTER_PARAMS as customerInvoiceFilterProps } from '../../invoice/customer/settings/filter-params';
import { FILTER_PARAMS as losSubscriptionFilterProps } from '../../los-subscription/settings/filter-params';
import { searchResultsFilterParams as loadBoardFilterProps } from '../../load-board/settings/field-settings';
import { FILTER_PARAMS as routeByLoadFilterProps } from '../../dispatch-report/route/route-by-load/settings';
import { FILTER_PARAMS as carrierRateRequestFilterParams } from '../../carrier-rate-request-report/settings';
import { filterProps as contractAwardedLineFilterParams } from '../../carrier-profile/settings/awarded-lane';
import { FILTER_PARAMS as fleetTruckDailyLogFilterParams } from '../../fleet-profile/truck/settings/daily-log';
import { FILTER_PARAMS as equipmentServiceInvoiceFilterParams } from '../../equipment-service-invoice/settings';
import { FILTER_PARAMS as payrollAccessorialFilterProps } from '../../fleet-profile/settings/payroll-accessorial';
import { FILTER_PARAMS as fleetDriverDailyLogFilterParams } from '../../fleet-profile/driver/settings/daily-hours';
import { loadFilterProps, routeFilterProps, orderFilterProps } from '../../dispatch-report/settings/filter-params';
import { FIELDS_AND_FILTER_PARAMS as carrierContractParams } from '../../contracts/carrier/settings/filter-params';
import { filterProps as carrierContractRatePriceFilterParams } from '../../carrier-profile/settings/contract-rate';
import { driverChargesFilterProps, vendorChargesFilterProps } from '../../payroll/settings/charges-table-settings';
import { FIELDS_AND_FILTER_PARAMS as customerContractParams } from '../../contracts/customer/settings/filter-params';
import {
  filterProps as cloEventFilterProps,
} from '../../dispatch-planner-events-v2/settings/clo-events-table-settings';
import { FILTER_PARAMS as serviceVendorInvoiceFilterProps } from '../../invoice/service-vendor/settings/filter-params';
import {
  FILTER_PARAMS as trailerMilestoneLogFilterParams,
} from '../../fleet-profile/trailer/settings/trailer-tracking';
import {
  getFilterParamsByReportTypeForEditReport as getTemplateFilterParamsByReportType,
} from '../../template/report/settings';
import {
  VENDOR_FILTER_PARAMS,
  FILTER_PARAMS as getDriverPayrollFilterProps,
} from '../../payroll/settings/filter-params';
import {
  REPORT_FILTER_PARAMS as geoFencingZoneReportFilterParams,
  RATING_FILTER_PARAMS as geoFencingZoneRatingFilterParams,
} from '../../geo-fencing-zone/settings/filter-params';
import {
  truckDocumentsFilterParams,
  driverDocumentsFilterParams,
  trailerDocumentsFilterParams,
} from '../../fleet-documents/settings';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
//////////////////////////////////////////////////

export const FILTER_PARAMS = [
  {
    type: 'string',
    value: GC.FIELD_BRANCH_DOT_BRANCH_NAME,
    name: G.getWindowLocale('titles:branch-name', 'Branch Name'),
  },
  {
    type: 'string',
    value: GC.FIELD_NAME,
    name: G.getWindowLocale('titles:name', 'Name'),
  },
  {
    type: 'string',
    value: GC.FIELD_TYPE,
    name: G.getWindowLocale('titles:type', 'Type'),
  },
  {
    type: 'string',
    value: GC.FIELD_OWNER,
    name: G.getWindowLocale('titles:owner', 'Owner'),
  },
  {
    type: 'boolean',
    value: GC.FIELD_PROMPT,
    name: G.getWindowLocale('titles:prompt', 'Prompt'),
  },
  {
    type: 'string',
    value: GC.FIELD_DESCRIPTION,
    name: G.getWindowLocale('titles:description', 'Description'),
  },
  {
    type: 'string',
    collection: true,
    disableFilter: true,
    value: GC.FIELD_ROLE_GUIDS,
    name: G.getWindowLocale('titles:roles', 'Roles'),
  },
  {
    type: 'string',
    value: GC.FIELD_CREATED_BY,
    name: G.getWindowLocale('titles:created-by', 'Created By'),
  },
  {
    type: 'date',
    value: GC.FIELD_CREATED_DATE,
    name: G.getWindowLocale('titles:created-date', 'Created Date'),
  },
  {
    type: 'date',
    value: GC.FIELD_LAST_MODIFIED_DATE,
    name: G.getWindowLocale('titles:last-modified-date', 'Last Modified Date'),
  },
];

export const paramsByType = {
  [GC.EDI_REPORT]: ediParams,
  [GC.USER_REPORT]: userParams,
  [GC.TEL_REPORT]: loadFilterProps,
  [GC.REPORT_REPORT]: FILTER_PARAMS,
  [GC.CLO_REPORT]: orderFilterProps,
  [GC.IFTA_REPORT]: iftaFilterProps,
  [GC.ROUTE_REPORT]: routeFilterProps,
  [GC.CLAIM_REPORT]: claimFilterParams,
  [GC.BRANCH_REPORT]: branchFilterProps,
  [GC.CARRIER_REPORT]: carrierFilterProps,
  [GC.CLO_ITEM_REPORT]: cloItemFilterParams,
  [GC.CLO_EVENT_REPORT]: cloEventFilterProps,
  [GC.FUEL_CARD_REPORT]: fuelCardFilterProps,
  [GC.TEL_EVENT_REPORT]: telEventFilterParams,
  [GC.TEL_BY_CLO_REPORT]: telByCloFilterParams,
  [GC.CLO_BY_TEL_REPORT]: cloByTelFilterParams,
  [GC.ROUTE_CLO_REPORT]: getCLOFilterParams({}),
  [GC.ROUTE_TEL_REPORT]: getTELFilterParams({}),
  [GC.IMPORT_REPORT_REPORT]: importFilterParams,
  [GC.REFERENCE_REPORT]: getReferenceFilterProps,
  [GC.TOLL_CHARGE_REPORT]: tollChargeFilterProps,
  [GC.INSPECTION_REPORT]: inspectionFilterParams,
  [GC.ORDER_REQUEST_REPORT]: publicCloFilterProps,
  [GC.INVOICE_EDI_REPORT]: carrierEdiFilterParams,
  [GC.VENDOR_PAYROLL_REPORT]: VENDOR_FILTER_PARAMS,
  [GC.PAYROLL_REPORT]: getDriverPayrollFilterProps,
  [GC.CUSTOMER_PORTAL_CLO_REPORT]: orderFilterProps,
  [GC.ROUTE_BY_LOAD_REPORT]: routeByLoadFilterProps,
  [GC.CLO_RATE_CHARGE_REPORT]: cloChargeFilterParams,
  [GC.TEL_RATE_CHARGE_REPORT]: telChargeFilterParams,
  [GC.CARRIER_CONTRACT_REPORT]: carrierContractParams,
  [GC.ORDER_QUOTE_REPORT]: ORDER_QUOTES_FILTER_PARAMS,
  [GC.VENDOR_INVOICE_REPORT]: vendorInvoiceFilterProps,
  [GC.CUSTOMER_CONTRACT_REPORT]: customerContractParams,
  [GC.EXTERNAL_LOAD_BOARD_REPORT]: loadBoardFilterProps,
  [GC.SERVICE_VENDOR_REPORT]: serviceVendorFilterParams,
  [GC.TASK_MANAGEMENT_REPORT]: taskManagementFilterParams,
  [GC.CARRIER_INVOICE_REPORT]: carrierInvoiceFilterParams,
  [GC.CUSTOMER_INVOICE_REPORT]: customerInvoiceFilterProps,
  [GC.LOS_SUBSCRIPTION_REPORT]: losSubscriptionFilterProps,
  [GC.CARRIER_INSURANCE_REPORT]: carrierInsuranceFilterParams,
  [GC.CARRIER_STATISTIC_REPORT]: carrierStatisticFilterParams,
  [GC.DRIVER_PAYROLL_INVOICE_REPORT]: driverInvoiceFilterProps,
  [GC.EXCEL_RATING_RESULT_REPORT]: EXCEL_RESULTS_FILTER_PARAMS,
  [GC.CUSTOMER_MASTER_INVOICE_REPORT]: masterInvoiceFilterProps,
  [GC.CARRIER_RATE_REQUEST_REPORT]: carrierRateRequestFilterParams,
  [GC.SERVICE_VENDOR_INVOICE_REPORT]: serviceVendorInvoiceFilterProps,
  [GC.CARRIER_CONTRACT_AWARDED_LINE_REPORT]: Object.values(contractAwardedLineFilterParams),
  [GC.CUSTOMER_CONTRACT_AWARDED_LINE_REPORT]: Object.values(contractAwardedLineFilterParams),
  [GC.CARRIER_CONTRACT_RATE_PRICE_REPORT]: Object.values(carrierContractRatePriceFilterParams),
  // pivot
  [GC.PIVOT_TEL_REPORT]: loadFilterProps,
  [GC.PIVOT_CLO_REPORT]: orderFilterProps,
  [GC.PIVOT_FUEL_CARD_REPORT]: fuelCardFilterProps,
  [GC.PIVOT_TOLL_CHARGE_REPORT]: tollChargeFilterProps,
  [GC.PIVOT_VENDOR_PAYROLL_REPORT]: VENDOR_FILTER_PARAMS,
  [GC.PIVOT_ROUTE_BY_LOAD_REPORT]: routeByLoadFilterProps,
  [GC.PIVOT_PAYROLL_CHARGES_REPORT]: driverChargesFilterProps,
  [GC.PIVOT_DRIVER_PAYROLL_REPORT]: getDriverPayrollFilterProps,
  [GC.PIVOT_CUSTOMER_INVOICE_REPORT]: customerInvoiceFilterProps,
  [GC.PIVOT_VENDOR_PAYROLL_CHARGES_REPORT]: vendorChargesFilterProps,
  [GC.PIVOT_FLEET_EQUIPMENT_SERVICE_REPORT]: getFilterParamsByReportType(GC.FLEET_EQUIPMENT_SERVICE_REPORT),
  // fleet
  [GC.WORK_ORDER_REPORT]: workOrderFilterParams,
  [GC.FLEET_TRUCK_DOCUMENT_VIEW_REPORT]: truckDocumentsFilterParams,
  [GC.FLEET_TRUCK_DAILY_LOG_REPORT]: fleetTruckDailyLogFilterParams,
  [GC.TRAILER_MILESTONE_LOG_REPORT]: trailerMilestoneLogFilterParams,
  [GC.FLEET_DRIVER_DAILY_LOG_REPORT]: fleetDriverDailyLogFilterParams,
  [GC.FLEET_COMPENSATION_GROUP_REPORT]: compensationGroupFilterParams,
  [GC.FLEET_DRIVER_DOCUMENT_VIEW_REPORT]: driverDocumentsFilterParams,
  [GC.FLEET_TRAILER_DOCUMENT_VIEW_REPORT]: trailerDocumentsFilterParams,
  [GC.FLEET_DRIVER_COMPENSATION_REPORT]: fleetCompensationFilterParams(),
  [GC.FLEET_VENDOR_COMPENSATION_REPORT]: fleetCompensationFilterParams(true),
  [GC.FLEET_TRUCK_REPORT]: getFilterParamsByReportType(GC.FLEET_TRUCK_REPORT),
  [GC.GEO_FENCING_LOCATION_REPORT]: Object.values(getGeoFencingFilterParams()),
  [GC.FLEET_VENDOR_REPORT]: getFilterParamsByReportType(GC.FLEET_VENDOR_REPORT),
  [GC.FLEET_DRIVER_REPORT]: getFilterParamsByReportType(GC.FLEET_DRIVER_REPORT),
  [GC.FLEET_TRAILER_REPORT]: getFilterParamsByReportType(GC.FLEET_TRAILER_REPORT),
  [GC.FLEET_EQUIPMENT_SERVICE_INVOICE_REPORT]: equipmentServiceInvoiceFilterParams,
  [GC.FLEET_SERVICE_ISSUE_REPORT]: getFilterParamsByReportType(GC.FLEET_SERVICE_ISSUE_REPORT),
  [GC.FLEET_DRIVER_EXPENSE_REPORT]: getFilterParamsByReportType(GC.FLEET_DRIVER_EXPENSE_REPORT),
  [GC.FLEET_SHARED_COMPONENT_REPORT]: getFilterParamsByReportType(GC.FLEET_SHARED_COMPONENT_REPORT),
  [GC.FLEET_EQUIPMENT_SERVICE_REPORT]: getFilterParamsByReportType(GC.FLEET_EQUIPMENT_SERVICE_REPORT),
  [GC.FLEET_VENDOR_ASSESSORIAL_REPORT]: fleetAccessorialFilterParams({
    disableAccessorialFilter: true,
  }),
  [GC.FLEET_DRIVER_PAYROLL_ASSESSORIAL_REPORT]: payrollAccessorialFilterProps({
    disableAccessorialFilter: true,
  }),
  [GC.FLEET_DRIVER_ASSESSORIAL_REPORT]: fleetAccessorialFilterParams({
    fleetType: GC.FIELD_DRIVER,
    disableAccessorialFilter: true,
  }),
  [GC.FLEET_VENDOR_PAYROLL_ASSESSORIAL_REPORT]: payrollAccessorialFilterProps({
    fleetType: GC.FIELD_VENDOR,
    disableAccessorialFilter: true,
  }),
  // fleet assignment history
  [GC.DRIVER_TRUCK_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.DRIVER_TRUCK_ASSIGNMENT_HISTORY_REPORT,
    'truck',
  ),
  [GC.TRUCK_DRIVER_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.TRUCK_DRIVER_ASSIGNMENT_HISTORY_REPORT,
    'driver',
  ),
  [GC.TRAILER_DRIVER_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.TRAILER_DRIVER_ASSIGNMENT_HISTORY_REPORT,
    'driver',
  ),
  [GC.DRIVER_TRAILER_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.DRIVER_TRAILER_ASSIGNMENT_HISTORY_REPORT,
    'trailer',
  ),
  [GC.FLEET_VENDOR_TRUCK_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.FLEET_VENDOR_TRUCK_ASSIGNMENT_HISTORY_REPORT,
    'truck',
  ),
  [GC.FLEET_VENDOR_DRIVER_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.FLEET_VENDOR_DRIVER_ASSIGNMENT_HISTORY_REPORT,
    'driver',
  ),
  [GC.TRUCK_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.TRUCK_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT,
    'fleetVendor',
  ),
  [GC.FLEET_VENDOR_TRAILER_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.FLEET_VENDOR_TRAILER_ASSIGNMENT_HISTORY_REPORT,
    'trailer',
  ),
  [GC.DRIVER_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.DRIVER_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT,
    'fleetVendor',
  ),
  [GC.TRAILER_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.TRAILER_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT,
    'fleetVendor',
  ),
  [GC.DRIVER_TEAM_DRIVER_ASSIGNMENT_HISTORY_REPORT]: getAssignmentHistoryFilterParams(
    GC.DRIVER_TEAM_DRIVER_ASSIGNMENT_HISTORY_REPORT,
    'driver',
  ),
  // template
  [GC.REPORT_GEO_FENCING_ZONE_REPORT]: geoFencingZoneReportFilterParams,
  [GC.RATING_GEO_FENCING_ZONE_REPORT]: geoFencingZoneRatingFilterParams,
  [GC.ITEM_REPORT]: getTemplateFilterParamsByReportType(GC.ITEM_REPORT),
  [GC.INSPECTION_TEMPLATE]: Object.values(inspectionTemplateFilterProps),
  [GC.CONTACT_BOOK_REPORT]: getTemplateFilterParamsByReportType(GC.CONTACT_BOOK_REPORT),
  [GC.CLO_TEMPLATE_REPORT]: getTemplateFilterParamsByReportType(GC.CLO_TEMPLATE_REPORT),
  [GC.ROUTE_TEMPLATE_REPORT]: getTemplateFilterParamsByReportType(GC.ROUTE_TEMPLATE_REPORT),
  [GC.LOCATION_TEMPLATE_REPORT]: getTemplateFilterParamsByReportType(GC.LOCATION_TEMPLATE_REPORT),
  [GC.CONTAINER_TEMPLATE_REPORT]: getTemplateFilterParamsByReportType(GC.CONTAINER_TEMPLATE_REPORT),
  [GC.SHARED_ACCESSORIAL_REPORT]: getTemplateFilterParamsByReportType(GC.SHARED_ACCESSORIAL_REPORT),
  [GC.COMPENSATION_TEMPLATE_REPORT]: getTemplateFilterParamsByReportType(GC.COMPENSATION_TEMPLATE_REPORT),
};

export const reportTypeLocaleMap = {
  [GC.EDI_REPORT]: 'titles:edi',
  [GC.TEL_REPORT]: 'titles:tel',
  [GC.CLO_REPORT]: 'titles:clo',
  [GC.IFTA_REPORT]: 'titles:ifta',
  [GC.USER_REPORT]: 'titles:user',
  [GC.ROUTE_REPORT]: 'titles:route',
  [GC.CHART_REPORT]: 'titles:chart',
  [GC.CLAIM_REPORT]: 'titles:claim',
  [GC.BRANCH_REPORT]: 'titles:branch',
  [GC.REPORT_REPORT]: 'titles:report',
  [GC.CARRIER_REPORT]: 'titles:carrier',
  [GC.CLO_ITEM_REPORT]: 'titles:clo-items',
  [GC.FUEL_CARD_REPORT]: 'titles:fuel-card',
  [GC.REFERENCE_REPORT]: 'titles:reference',
  [GC.TEL_EVENT_REPORT]: 'titles:tel-event',
  [GC.CLO_EVENT_REPORT]: 'titles:clo-event',
  [GC.ROUTE_TEL_REPORT]: 'titles:route-tel',
  [GC.ROUTE_CLO_REPORT]: 'titles:route-clo',
  [GC.IMPORT_REPORT_REPORT]: 'titles:import',
  [GC.WORK_ORDER_REPORT]: 'titles:work-order',
  [GC.TEL_BY_CLO_REPORT]: 'titles:tel-by-clo',
  [GC.PAYROLL_REPORT]: 'titles:driver-payroll',
  [GC.TOLL_CHARGE_REPORT]: 'titles:toll-charge',
  [GC.ORDER_REQUEST_REPORT]: 'titles:order-api',
  [GC.INVOICE_EDI_REPORT]: 'titles:carrier-edi',
  [GC.ORDER_QUOTE_REPORT]: 'titles:order-quote',
  [GC.ROUTE_BY_LOAD_REPORT]: 'titles:route-by-load',
  [GC.EXCEL_RATING_RESULT_REPORT]: 'titles:rate-shop',
  [GC.SERVICE_VENDOR_REPORT]: 'titles:service-vendor',
  [GC.VENDOR_INVOICE_REPORT]: 'titles:vendor-invoice',
  [GC.VENDOR_PAYROLL_REPORT]: 'titles:vendor-payroll',
  [GC.EXTERNAL_LOAD_BOARD_REPORT]: 'titles:load-board',
  [GC.CLO_RATE_CHARGE_REPORT]: 'titles:clo-rate-charge',
  [GC.TEL_RATE_CHARGE_REPORT]: 'titles:tel-rate-charge',
  [GC.CARRIER_INVOICE_REPORT]: 'titles:carrier-invoice',
  [GC.TASK_MANAGEMENT_REPORT]: 'titles:task-management',
  [GC.CARRIER_RATE_REQUEST_REPORT]: 'titles:bid-history',
  [GC.CARRIER_CONTRACT_REPORT]: 'titles:carrier-contract',
  [GC.CUSTOMER_INVOICE_REPORT]: 'titles:customer-invoice',
  [GC.CUSTOMER_PORTAL_CLO_REPORT]: 'titles:customer-portal',
  [GC.CUSTOMER_CONTRACT_REPORT]: 'titles:customer-contract',
  [GC.CARRIER_INSURANCE_REPORT]: 'titles:carrier-insurance',
  [GC.CARRIER_STATISTIC_REPORT]: 'titles:carrier-statistic',
  [GC.DRIVER_PAYROLL_INVOICE_REPORT]: 'titles:driver-invoice',
  [GC.CUSTOMER_MASTER_INVOICE_REPORT]: 'titles:master-invoice',
  [GC.CARRIER_CONTRACT_RATE_PRICE_REPORT]: 'titles:contract-rates',
  [GC.SERVICE_VENDOR_INVOICE_REPORT]: 'titles:service-vendor-invoice',
  [GC.CARRIER_CONTRACT_AWARDED_LINE_REPORT]: 'titles:carrier-contract-awarded-line',
  [GC.CUSTOMER_CONTRACT_AWARDED_LINE_REPORT]: 'titles:customer-contract-awarded-line',
  // pivot
  [GC.PIVOT_TEL_REPORT]: 'titles:tel-pivot',
  [GC.PIVOT_CLO_REPORT]: 'titles:clo-pivot',
  [GC.PIVOT_FUEL_CARD_REPORT]: 'titles:fuel-card-pivot',
  [GC.PIVOT_TOLL_CHARGE_REPORT]: 'titles:toll-charge-pivot',
  [GC.PIVOT_ROUTE_BY_LOAD_REPORT]: 'titles:route-by-load-pivot',
  [GC.PIVOT_DRIVER_PAYROLL_REPORT]: 'titles:driver-payroll-pivot',
  [GC.PIVOT_VENDOR_PAYROLL_REPORT]: 'titles:vendor-payroll-pivot',
  [GC.PIVOT_PAYROLL_CHARGES_REPORT]: 'titles:payroll-charges-pivot',
  [GC.PIVOT_CUSTOMER_INVOICE_REPORT]: 'titles:customer-invoice-pivot',
  [GC.PIVOT_FLEET_EQUIPMENT_SERVICE_REPORT]: 'titles:equipment-service-pivot',
  [GC.PIVOT_VENDOR_PAYROLL_CHARGES_REPORT]: 'titles:vendor-payroll-charges-pivot',
  // fleet
  [GC.FLEET_TRUCK_REPORT]: 'titles:truck',
  [GC.FLEET_VENDOR_REPORT]: 'titles:vendor',
  [GC.FLEET_DRIVER_REPORT]: 'titles:driver',
  [GC.FLEET_TRAILER_REPORT]: 'titles:trailer',
  [GC.INSPECTION_REPORT]: 'titles:inspection',
  [GC.FLEET_SERVICE_ISSUE_REPORT]: 'titles:issue',
  [GC.FLEET_DRIVER_EXPENSE_REPORT]: 'titles:driver-expense',
  [GC.FLEET_TRUCK_DAILY_LOG_REPORT]: 'titles:truck-daily-log',
  [GC.TRAILER_MILESTONE_LOG_REPORT]: 'titles:trailer-tracking',
  [GC.FLEET_DRIVER_DAILY_LOG_REPORT]: 'titles:driver-daily-log',
  [GC.FLEET_SHARED_COMPONENT_REPORT]: 'titles:shared-component',
  [GC.GEO_FENCING_LOCATION_REPORT]: 'titles:geo-fencing-location',
  [GC.FLEET_EQUIPMENT_SERVICE_REPORT]: 'titles:equipment-service',
  [GC.FLEET_DRIVER_ONBOARDING_REPORT]: 'titles:driver-onboarding',
  [GC.FLEET_TRUCK_DOCUMENT_VIEW_REPORT]: 'titles:truck-documents',
  [GC.FLEET_DRIVER_DOCUMENT_VIEW_REPORT]: 'titles:driver-documents',
  [GC.FLEET_VENDOR_ASSESSORIAL_REPORT]: 'titles:vendor-accessorial',
  [GC.FLEET_DRIVER_ASSESSORIAL_REPORT]: 'titles:driver-accessorial',
  [GC.FLEET_COMPENSATION_GROUP_REPORT]: 'titles:compensation-group',
  [GC.FLEET_DRIVER_COMPENSATION_REPORT]: 'titles:driver-compensation',
  [GC.FLEET_TRAILER_DOCUMENT_VIEW_REPORT]: 'titles:trailer-documents',
  [GC.FLEET_VENDOR_COMPENSATION_REPORT]: 'titles:vendor-compensation',
  [GC.FLEET_DRIVER_PAYROLL_ASSESSORIAL_REPORT]: 'titles:driver-payroll-accessorial',
  [GC.FLEET_VENDOR_PAYROLL_ASSESSORIAL_REPORT]: 'titles:vendor-payroll-accessorial',
  [GC.FLEET_EQUIPMENT_SERVICE_INVOICE_REPORT]: 'titles:fleet-equipment-service-invoice',
  // fleet assignment history
  [GC.TRUCK_DRIVER_ASSIGNMENT_HISTORY_REPORT]: 'titles:truck-driver-assignment-history',
  [GC.DRIVER_TRUCK_ASSIGNMENT_HISTORY_REPORT]: 'titles:driver-truck-assignment-history',
  [GC.DRIVER_TRAILER_ASSIGNMENT_HISTORY_REPORT]: 'titles:driver-trailer-assignment-history',
  [GC.TRAILER_DRIVER_ASSIGNMENT_HISTORY_REPORT]: 'titles:trailer-driver-assignment-history',
  [GC.DRIVER_TEAM_DRIVER_ASSIGNMENT_HISTORY_REPORT]: 'titles:team-driver-assignment-history',
  [GC.TRUCK_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT]: 'titles:truck-vendor-assignment-history',
  [GC.FLEET_VENDOR_TRUCK_ASSIGNMENT_HISTORY_REPORT]: 'titles:vendor-truck-assignment-history',
  [GC.DRIVER_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT]: 'titles:driver-vendor-assignment-history',
  [GC.FLEET_VENDOR_DRIVER_ASSIGNMENT_HISTORY_REPORT]: 'titles:vendor-driver-assignment-history',
  [GC.TRAILER_FLEET_VENDOR_ASSIGNMENT_HISTORY_REPORT]: 'titles:trailer-vendor-assignment-history',
  [GC.FLEET_VENDOR_TRAILER_ASSIGNMENT_HISTORY_REPORT]: 'titles:vendor-trailer-assignment-history',
  // template
  [GC.ITEM_REPORT]: 'titles:item',
  [GC.CONTACT_BOOK_REPORT]: 'titles:contact-book',
  [GC.CLO_TEMPLATE_REPORT]: 'titles:clo-template',
  [GC.LOCATION_TEMPLATE_REPORT]: 'titles:location',
  [GC.CONTAINER_TEMPLATE_REPORT]: 'titles:container',
  [GC.ROUTE_TEMPLATE_REPORT]: 'titles:route-template',
  [GC.INSPECTION_TEMPLATE]: 'titles:inspection-template',
  [GC.SHARED_ACCESSORIAL_REPORT]: 'titles:shared-accessorial',
  [GC.COMPENSATION_TEMPLATE_REPORT]: 'titles:compensation-template',
  [GC.REPORT_GEO_FENCING_ZONE_REPORT]: 'titles:report-geo-fencing-zone',
  [GC.RATING_GEO_FENCING_ZONE_REPORT]: 'titles:rating-geo-fencing-zone',
  // TODO: uncomment if needed
  // [GC.CLO_EVENT_REPORT]: cloEventFilterProps,
  // [GC.ROUTE_CLO_REPORT]: getCLOFilterParams({}),
  // [GC.ROUTE_TEL_REPORT]: getTELFilterParams({}),
  // [GC.LOS_SUBSCRIPTION_REPORT]: losSubscriptionFilterProps,
};
